import { render, staticRenderFns } from "./InventoryFormAssignUsers.vue?vue&type=template&id=3f3a74d8"
import script from "./InventoryFormAssignUsers.vue?vue&type=script&lang=js"
export * from "./InventoryFormAssignUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports